import React from "react";
import { connect } from "react-redux";

class HeroSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section className="hero-section hero-section-2 ptb-100">
          <div className="circles">
            <div className="heart animated-point-1"></div>
           <div className="heart animated-point-2"></div>
            <div className="heart animated-point-3"></div>
            <div className="heart animated-point-4"></div>
            <div className="heart animated-point-5"></div>
            <div className="heart animated-point-6"></div>
            <div className="heart animated-point-7"></div>
            <div className="heart animated-point-8"></div>
            <div className="heart animated-point-9"></div> 
          </div>
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-6 col-lg-6">
                <div className="hero-content-left ptb-100 text-white">
                  <h1 className="text-white">
                    <span>Continue with your Wedding Plans</span> with your out-of-town guests joining virtually
                  </h1>
                  <p className="lead">
                    Carolina Elite has created it's own proprietary suite of apps that allow guests who can't make it in person to join virtually.
                  </p>

                  <a href="#promo" className="btn app-store-btn page-scroll">
                    Learn More
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-lg-5">
                <div className="hero-animation-img">
                  <img
                    className="img-fluid d-block animation-one"
                    src="img/computer.svg"
                    alt="animation"
                  />
                  <img
                    className="img-fluid d-block d-lg-block animation-two"
                    src="img/bride-groom.svg"
                    alt="animation"
                    width="120"
                  />
                  <img
                    className="img-fluid d-block d-lg-block animation-three"
                    src="img/indiancouple.png"
                    alt="animation"
                    width="120"
                  />
              
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  state
}))(HeroSection);
